export default "__VITE_ASSET__BvoCbwdu__"